import React, { useState } from 'react';
import Loader from 'components/atoms/loader';
import AiManagementHiringHistoryDrawer from 'components/organisms/ai_management_hiring_history_drawer';
import { useHiringHistoryBiddings } from 'hooks/useHiringHistoryBiddings';
import { count, money } from 'services/ai_management_format';
import { Card } from './styles';

interface AiManagementHiringHistoryBiddingsProps {
  biddingId: number | null;
  itemKey: string;
}

const AiManagementHiringHistoryBiddings: React.FC<AiManagementHiringHistoryBiddingsProps> = ({
  biddingId,
  itemKey,
}) => {
  const { biddings, loading, error } = useHiringHistoryBiddings(biddingId, itemKey);
  const [opened, setOpened] = useState<{ id: number; notice: string | null } | null>(null);

  if (loading) {
    return (
      <div className="py-4">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-warning mb-0" role="alert">
        Não foi possível carregar as licitações anteriores deste item.
      </div>
    );
  }

  return (
    <Card className="card">
      <div className="card-header biddings-header font-weight-bold">Licitações anteriores</div>
      <div className="table-responsive">
        <table className="table mb-0">
          <thead className="thead-light">
            <tr className="text-nowrap">
              <th scope="col">Licitação</th>
              <th scope="col">Valor Negociado</th>
              <th scope="col">Quantidade de itens</th>
              <th scope="col">Total de Participantes</th>
              <th scope="col">Descrição do item</th>
            </tr>
          </thead>
          <tbody>
            {biddings.map((bidding) => (
              <tr key={bidding.biddingId}>
                <td className="text-nowrap">
                  {bidding.notice ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 align-baseline"
                      onClick={() => setOpened({ id: bidding.biddingId, notice: bidding.notice })}
                    >
                      {bidding.notice}
                    </button>
                  ) : (
                    <span className="text-muted">Sem resultado</span>
                  )}
                </td>
                <td className="text-nowrap">{money(bidding.value)}</td>
                <td className="text-nowrap">{count(bidding.quantity)}</td>
                <td className="text-nowrap">{count(bidding.participants)}</td>
                <td
                  className="description-cell text-truncate"
                  title={bidding.description ?? undefined}
                >
                  {bidding.description ?? '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {opened ? (
        <AiManagementHiringHistoryDrawer
          biddingId={biddingId}
          historicBiddingId={opened.id}
          itemKey={itemKey}
          notice={opened.notice}
          onClose={() => setOpened(null)}
        />
      ) : null}
    </Card>
  );
};

export default AiManagementHiringHistoryBiddings;
